export const getFormatPrice = (price, currency = 'EUR', language) => {
  return new Intl.NumberFormat(language, { style: 'currency', currency }).format(price)
}
